import React, {useEffect, useState} from 'react';
import {ErrorBoundary, pageFeeder} from "../helpers";
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import {Service} from "../Api";
import {connect} from "react-redux";
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(theme => ({
        root: {
            paddingTop: window.innerWidth >= 768 ? 14 : theme.mixins.toolbar.minHeight / 10 ,
            width: '100%'
        },
        bg: {
            height:window.innerHeight
        }
    }));

const ServerComponentCaller = ({url}) => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [loading, setLoad] = useState(true);
    useEffect(() => {
            async function fetchData(url){
                const res = await Service.get(url, (status, fetched) => fetched);
                setData(res);
                setLoad(false);
            }
            fetchData(url)
    }, [] );
    return <ErrorBoundary>
        {
            loading
                ?  <div className={classes.root}>
                    <LinearProgress />
                    <div className={classes.bg}/>
                </div>
                :   <Fade in={!loading || loading} timeout={500}>
                    {pageFeeder(data)}
                </Fade>
        }
    </ErrorBoundary>
}

export default connect(null,{})(ServerComponentCaller);